import { render, staticRenderFns } from "./ProductAddOnItemsEdit.vue?vue&type=template&id=8dc7af4a"
import script from "./ProductAddOnItemsEdit.vue?vue&type=script&lang=js"
export * from "./ProductAddOnItemsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports